<template>
  <div>
    <v-snackbar v-model="snackbar" :color="snackbarColor">
      {{ snackbarContent }}
      <v-btn text @click="snackbar = false" timeout="3000">{{$t('close')}}</v-btn>
    </v-snackbar>

    <v-container class="mt-12">
      <v-card class="mx-auto" width="95%">
        <v-card-title>
          Trainers
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-account-search-outline"
            label="Rechercher"
            single-line
            hide-details
          ></v-text-field>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                fab
                class="mx-5 primary--text"
                color="secondary"
                v-on="on"
                @click="openTrainerDialog(1)"
              >
                <v-icon>mdi-account-plus</v-icon>
              </v-btn>
            </template>
            <span>{{$t('trainer.addNewTrainer')}}</span>
          </v-tooltip>
        </v-card-title>

        <v-data-table
          :search="search"
          :headers="headers"
          :items="trainers"
          class="elevation-1"
          :loading="trainersLoader"
        >
          <template v-slot:item.gender="{ item }">
           {{item.gender == 'M'? 'Mâle': 'Femelle'}}
          </template>

          <template v-slot:item.address="{ item }">
            {{ item.address.address }}, {{item.address.city.cityName.charAt(0).toUpperCase() + item.address.city.cityName.substring(1)}}
            <br />
            <span style=" font-style: italic;">{{item.address.pinCode}}</span>
          </template>

          <template v-slot:item.emailVerified="{ item }">
            <v-chip dark v-if="item.emailVerified" color="green">
              <v-icon>mdi-email-check-outline</v-icon>
            </v-chip>
            <v-chip dark v-else color="red">
              <v-icon>mdi-email-alert-outline</v-icon>
            </v-chip>
          </template>

          <template v-slot:item.action="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  small
                  dark
                  fab
                  color="green lighten-2"
                  class="mx-1 my-3"
                  @click="openViewScheduleDialog(item)"
                >
                  <v-icon v-on="on">mdi-account-clock-outline</v-icon>
                </v-btn>
              </template>
              <span>{{$t('trainer.viewSchedule')}}</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  small
                  dark
                  fab
                  color="yellow darken-3"
                  class="mx-1 my-3"
                  @click="editTrainer(item, 2)"
                >
                  <v-icon v-on="on">mdi-account-edit-outline</v-icon>
                </v-btn>
              </template>
              <span>{{$t('trainer.editTrainer')}}</span>
            </v-tooltip>

            <!-- <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  small
                  dark
                  fab
                  color="red darken-2"
                  class="mx-1 my-3"
                  @click="deleteTrainer(item)"
                >
                  <v-icon v-on="on">mdi-account-remove-outline</v-icon>
                </v-btn>
              </template>
              <span>Delete Trainer</span>
            </v-tooltip>-->

            <v-tooltip bottom v-if="item.accountNonLocked == true">
              <template v-slot:activator="{ on }">
                <v-btn
                  class="elevation-1 white--text mx-1"
                  color="blue lighten-3"
                  fab
                  small
                  @click="openBlockUserDialog(item.id, item.accountNonLocked)"
                  :disabled="item.id == user.id"
                >
                  <v-icon right class="mr-2" v-on="on">mdi-account-cancel-outline</v-icon>
                </v-btn>
              </template>
              <span>{{$t('trainer.blockTrainer')}}</span>
            </v-tooltip>

            <v-tooltip bottom v-else>
              <template v-slot:activator="{ on }">
                <v-btn
                  class="elevation-1 white--text"
                  color="blue darken-4"
                  fab
                  small
                  @click="openBlockUserDialog(item.id, item.accountNonLocked)"
                  :disabled="item.id == user.id"
                >
                  <v-icon right class="mr-2" v-on="on">mdi-account-check-outline</v-icon>
                </v-btn>
              </template>
              <span>{{$t('trainer.unblockTrainer')}}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card>
    </v-container>

    <v-dialog v-model="trainerDialog" width="70%" persistent>
      <v-card>
        <v-card-title class="headline primary white--text pa-2" primary-title>{{trainerDialogTitle}}</v-card-title>
        <v-card-text class="my-4">
          <v-form v-model="formValid" class="ma-0" ref="form">
            <v-layout row wrap class="justify-space-around">
              <!-- Name -->
              <v-flex xs12 md6 class="px-3">
                <v-text-field
                  v-model="firstname"
                  :rules="nameRules"
                  :counter="20"
                  label="Prénom"
                  required
                ></v-text-field>
              </v-flex>
              <!-- Last Name -->
              <v-flex xs12 md6 class="px-3">
                <v-text-field
                  v-model="lastname"
                  :rules="nameRules"
                  :counter="20"
                  label="Nom de famille"
                  required
                ></v-text-field>
              </v-flex>
              <!-- Email -->
              <v-flex xs12 md6 class="px-3">
                <v-text-field
                  v-model="email"
                  :rules="emailRules"
                  label="Email"
                  required
                  :disabled="emailDisabled"
                ></v-text-field>
              </v-flex>
              <!-- Telephone number -->
              <v-flex xs12 md6 class="px-3">
                <v-text-field
                  v-model="phonenumber"
                  :rules="phoneRules"
                  :disabled="emailDisabled"
                  label="Numéro de téléphone"
                  required
                ></v-text-field>
              </v-flex>
              <!-- Gender -->
              <v-flex xs12 md6 class="px-3">
                <v-select
                  :items="gender"
                  item-text="item"
                  item-value="value"
                  label="Le genre"
                  :rules="[v => !!v || 'Le sexe est requis']"
                  v-model="genderSelect"
                ></v-select>
              </v-flex>
              <!-- Type -->
              <v-flex xs12 md6 class="px-3">
                <v-select
                  v-model="typeOfTrainer"
                  :items="trainerType"
                  :disabled="emailDisabled"
                  item-text="item"
                  item-value="value"
                  label="Sélectionner le genre"
                ></v-select>
              </v-flex>
              <!-- Date of birth -->
              <v-flex xs12 md12 class="px-3">
                <v-layout row wrap class="justify-space-between">
                  <v-flex xs12 md2 class="text-xs-left">
                    <h3 class="grey--text text--darken-2 pt-4">Date de naissance:</h3>
                  </v-flex>

                  <v-flex xs12 md3 class="px-3">
                    <v-select
                      :items="days"
                      label="journée"
                      :rules="[v => !!v || 'La date est obligatoire']"
                      v-model="day"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 md3 class="px-3">
                    <v-select
                      :items="months"
                      item-text="item"
                      item-value="value"
                      label="Mois"
                      :rules="[v => !!v || 'Le mois est obligatoire']"
                      v-model="month"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 md3 class="px-3">
                    <v-select
                      :items="years"
                      label="An"
                      :rules="[v => !!v || 'L\'année est obligatoire']"
                      v-model="year"
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-flex>

              <!-- Street -->
              <v-flex xs12 md4 class="pa-2">
                <v-text-field
                  v-model="street"
                  :rules="[v => !!v || 'La rue est obligatoire']"
                  label="Rue"
                  required
                ></v-text-field>
              </v-flex>
              <!-- Pincode -->
              <v-flex xs12 md4 class="pa-2">
                <v-text-field v-model="pincode" :rules="pincodeRules" label="Pincode" required></v-text-field>
              </v-flex>

              <!-- City -->
              <v-flex xs12 md4 class="pa-2">
                <!-- <v-text-field v-model="city" :rules="nameRules" label="City" required></v-text-field> -->
                <v-select
                  v-model="city"
                  :items="cities"
                  item-text="cityName"
                  item-value="id"
                  label="Ville"
                  persistent-hint
                  return-object
                  single-line
                  required
                ></v-select>
              </v-flex>

              <!-- Certificate number -->
              <v-flex xs12 md6 class="px-3">
                <v-text-field
                  v-model="certificateNumber"
                  :rules="[v => !!v || 'Le numéro de certificat est requis']"
                  label="Numéro de certificat"
                  required
                ></v-text-field>
              </v-flex>

              <!-- validity date -->
              <v-flex xs12 md6 class="px-3">
                <v-menu
                  ref="smenu"
                  v-model="smenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="validityDate"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                  :rules="[v => !!v || 'Sélectionnez une date de validité']"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="validityDateFormatted"
                      label="Date de validité"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="validityDate" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn outlined color="primary" @click="smenu = false">{{$t('cancel')}}</v-btn>
                    <v-btn color="primary" @click="validityDateChosen">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="!formValid"
            color="green darken-3"
            class="white--text px-5"
            :loading="addTrainerLoader"
            @click="registerTrainer"
          >{{$t('submit')}}</v-btn>

          <v-btn color="red darken-3" dark @click="resetTrainerForm()" class="px-5">{{$t('close')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="viewScheduleDialog" width="80%" persistent>
      <v-card>
        <v-card-title
          class="headline primary lighten-1 white--text pa-2"
          primary-title
        >{{trainerScheduleDialogTitle}}</v-card-title>
        <v-card-text class="my-4">
          <div align="right">
            <span>
              <span style="background-color:#00ab66; border-radius: 10px" class="px-6 mx-3"></span>
              Disponible
              <!-- Available -->
            </span>
            <span>
              <span style="background-color:red; border-radius: 10px" class="px-6 mx-5"></span>
              Attribué
              <!-- Assigned -->
            </span>
          </div>

          <v-row class="fill-height mt-12 elevation-3">
            <v-progress-linear v-if="calendarLoader" indeterminate color="loader" height="5"></v-progress-linear>
            <v-col>
              <v-sheet height="64">
                <v-toolbar flat color="white">
                  <v-btn outlined class="mr-4" @click="setToday">Aujourd'hui</v-btn>
                  <v-btn fab text small @click="prev">
                    <v-icon small>mdi-chevron-left</v-icon>
                  </v-btn>
                  <v-btn fab text small @click="next">
                    <v-icon small>mdi-chevron-right</v-icon>
                  </v-btn>
                  <v-toolbar-title class="mx-8">{{title}}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-menu bottom right>
                    <template v-slot:activator="{ on }">
                      <v-btn outlined v-on="on">
                        <span>{{ typeToLabel[type] }}</span>
                        <v-icon right>mdi-menu-down</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="type = 'day'">
                        <v-list-item-title>journée</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="type = 'week'">
                        <v-list-item-title>La semaine</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="type = 'month'">
                        <v-list-item-title>Mois</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="type = '4day'">
                        <v-list-item-title>4 jours</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>

                  <!-- <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        fab
                        @click="scheduleDialog = true"
                        class="mx-5 mb-2 white--text"
                        color="secondary"
                        v-on="on"
                      >
                        <v-icon>mdi-account-clock</v-icon>
                      </v-btn>
                    </template>
                    <span>Add new dates</span>
                  </v-tooltip>-->
                </v-toolbar>
              </v-sheet>
              <v-sheet height="550">
                <v-calendar
                  ref="calendar"
                  v-model="focus"
                  color="primary"
                  locale="fr"
                  :events="events"
                  :event-color="getEventColor"
                  :event-margin-bottom="3"
                  :now="today"
                  :type="type"
                  @click:event="showEvent"
                  @click:more="viewDay"
                  @click:date="viewDay"
                  @change="updateRange"
                ></v-calendar>

                <v-menu
                  v-model="selectedOpen"
                  :close-on-content-click="false"
                  :activator="selectedElement"
                  offset-x
                >
                  <v-card color="grey lighten-4" min-width="350px" flat>
                    <v-toolbar color="red" dark>
                      <v-toolbar-title v-html="selectedEvent.uniqueIdentifier"></v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                      <span></span>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn text color="red" @click="selectedOpen = false">{{$t('close')}}</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-menu>
              </v-sheet>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="red darken-3"
            dark
            @click="viewScheduleDialog = false; "
            class="px-5"
          >{{$t('close')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="blockUserDialog" width="30%">
      <v-card>
        <v-card-title class="headline primary white--text pa-2" primary-title>{{blockDialogTitle}}</v-card-title>
        <v-card-actions class="pt-12 pb-4 mx-2">
          <v-spacer></v-spacer>
          <v-btn color="success" @click="blockUnblockUser">Oui</v-btn>
          <v-btn color="red" dark @click="blockUserDialog = false">Non</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";

var today = new Date(Date.now()).toISOString().slice(-24, -14);

export default {
  data() {
    return {
      trainerDialog: false,
      trainerDialogTitle: "Ajouter un nouveau formateur",
      formValid: false,
      addTrainerLoader: false,
      trainersLoader: false,
      trainerScheduleDialogTitle: "",
      trainerDialogAction: null,
      trainerEditID: null,

      snackbar: false,
      snackbarContent: "",
      snackbarColor: "",

      blockUserDialog: false,

      cities: [],

      emailRules: [
        v => !!v || "L'email est requis",
        v => /.+@.+\..+/.test(v) || "L'email doit être valide"
      ],
      phoneRules: [
        v => !!v || "Le numéro de téléphone est requis",
        v => !isNaN(v) || "Le numéro de téléphone doit être valide",
        v =>
          (v && v.length === 10) ||
          "Le numéro de téléphone doit contenir 10 caractères"
      ],
      pincodeRules: [
        v => !!v || "Le code PIN est requis",
        v => !isNaN(v) || "Le code PIN doit être valide",
        v => (v && v.length === 5) || "Le code PIN doit comporter 5 caractères"
      ],
      nameRules: [
        v => !!v || "Le nom est requis",
        v => isNaN(v) || "Le nom doit être valide"
      ],
      rules: [v => !!v || "Field is required"],

      trainerType: [
        { item: "Psychologue", value: 2 },
        { item: "BAFM", value: 1 }
      ],

      days: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31"
      ],
      months: [
        { item: "Janvier", value: "01" },
        { item: "Février", value: "02" },
        { item: "Mars", value: "03" },
        { item: "Avril", value: "04" },
        { item: "Mai", value: "05" },
        { item: "Juin", value: "06" },
        { item: "Juillet", value: "07" },
        { item: "Aout", value: "08" },
        { item: "Septembre", value: "09" },
        { item: "Octobre", value: "10" },
        { item: "Novembre", value: "11" },
        { item: "Décembre", value: "12" }
      ],

      gender: [
        { item: "Male", value: "M" },
        { item: "Female", value: "F" }
      ],

      firstname: "",
      lastname: "",
      email: "",
      phonenumber: "",
      genderSelect: "",
      typeOfTrainer: "",
      day: "",
      month: "",
      year: "",
      street: "",
      pincode: "",
      city: "",
      certificateNumber: "",

      trainers: [],
      search: "",
      trainerIsLoading: false,
      emailDisabled: false,

      addressID: null,

      headers: null,

      trainerID: null,

      today: today,
      focus: today,
      type: "month",
      typeToLabel: {
        month: "Mois",
        week: "La semaine",
        day: "journée",
        "4day": "4 jours"
      },
      calendarLoader: false,
      start: null,
      end: null,
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      eventColor: "event",

      events: [],

      scheduleDialog: false,
      formValidSchedule: false,
      selectedText: "",
      schedulePicker: [],

      viewScheduleDialog: false,

      blockDialogTitle: "",

      smenu: false,
      validityDate: "",
      validityDateFormatted: ""
    };
  },
  created() {
    this.i18n =
      this.$i18n.locale == "fr"
        ? this.$i18n.messages.fr
        : this.$i18n.messages.en;

    (this.headers = [
      { text: this.i18n.trainer.firstName, value: "firstname" },
      { text: this.i18n.trainer.lastName, value: "lastname" },
      { text: this.i18n.trainer.gender, value: "gender" },
      { text: "Email", value: "email" },
      { text: this.i18n.trainer.phoneNumber, value: "phoneNumber" },
      { text: this.i18n.trainer.address, value: "address" },
      { text: this.i18n.trainer.emailVerified, value: "emailVerified" },
      { text: "Actions", value: "action", sortable: false }
    ]),
      (this.trainersLoader = true);
    this.$http
      .get("/public/findCities")
      .then(res => {
        this.cities = res.data;
      })
      .catch(e => {
        //console.log(e.response);
      });

    this.$http
      .get("/training-center/" + this.user.id + "/findAll/trainer", {
        headers: { Authorization: "Bearer " + this.$store.state.token }
      })
      .then(res => {
        this.trainers = res.data;
        this.trainersLoader = false;

        console.log(this.trainers);
      })
      .catch(e => {
        //console.log(e.response);
        this.trainersLoader = false;
      });
  },
  methods: {
    formatDate(date) {
      if (!date) return null;

      //const [year, month, day] = date.split("-");
      let d = new Date(date);

      return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
    },
    // ---------------------------------------------------- Trainer register, edit, delete ----------------------------------------------------------//
    resetTrainerForm() {
      this.trainerDialog = false;
      this.formValid = false;

      this.addTrainerLoader = false;

      this.$refs.form.reset();
      this.emailDisabled = false;
    },
    openTrainerDialog(actionType) {
      this.trainerDialogTitle = "Ajouter un nouveau formateur";
      this.trainerDialogAction = 1;
      this.trainerDialog = true;
    },
    registerTrainer() {
      this.addTrainerLoader = true;

      if (this.trainerDialogAction == 1) {
        var data = {
          firstname: this.firstname,
          lastname: this.lastname,
          gender: this.genderSelect,
          password: this.phonenumber,
          address: {
            address: this.street,
            pinCode: this.pincode,
            city: {
              id: this.city.id
            }
          },
          dateOfBirth: this.year + "-" + this.month + "-" + this.day,
          phoneNumber: this.phonenumber,
          email: this.email,
          certificateNumber: this.certificateNumber
        };

        this.$http
          .post(
            "/training-center/" +
              this.user.id +
              "/register/trainer/" +
              this.typeOfTrainer,
            data,
            {
              headers: { Authorization: "Bearer " + this.$store.state.token }
            }
          )
          .then(res => {
            //console.log(res);
            this.snackbarContent =
              "New trainer added. Email needs to be confirmed before they can be added to a course.";
            this.snackbarColor = "success";
            this.snackbar = true;
            this.resetTrainerForm();

            this.$http
              .get("/training-center/" + this.user.id + "/findAll/trainer", {
                headers: { Authorization: "Bearer " + this.$store.state.token }
              })
              .then(res => {
                this.trainers = res.data;
                this.trainersLoader = false;
              })
              .catch(e => {
                console.log(e.response);
                this.trainersLoader = false;

                this.snackbarContent = "Error getting data.";
                this.snackbarColor = "error";
                this.snackbar = true;
              });
          })
          .catch(e => {
            console.log(e.response);
            if (e.response.status == 409) {
              this.snackbarContent = "The email is already in use.";
              this.snackbarColor = "error";
              this.snackbar = true;

              this.trainersLoader = false;
            }
          });
      } else if (this.trainerDialogAction == 2) {
        var data2 = {
          firstname: this.firstname,
          lastname: this.lastname,
          gender: this.genderSelect,
          address: {
            id: this.addressID,
            address: this.street,
            pinCode: this.pincode,
            city: {
              id: this.city.id,
              cityName: this.city.cityName,
              department: this.city.department
            }
          },
          dateOfBirth: this.year + "-" + this.month.value + "-" + this.day,
          phoneNumber: this.phonenumber,
          email: this.email,
          certificateNumber: this.certificateNumber,
          certificateNumberValidityDate: this.validityDate + "T" + "00:00:00"
        };

        console.log(data2);

        this.$http
          .put(
            "/training-center/" +
              this.user.id +
              "/update-trainer/" +
              this.trainerEditID,
            data2,
            {
              headers: { Authorization: "Bearer " + this.$store.state.token }
            }
          )
          .then(res => {
            console.log(res);

            this.snackbarContent = "Details saved.";
            this.snackbarColor = "success";
            this.snackbar = true;
            this.resetTrainerForm();

            this.$http
              .get("/training-center/" + this.user.id + "/findAll/trainer", {
                headers: { Authorization: "Bearer " + this.$store.state.token }
              })
              .then(res => {
                this.trainers = res.data;
                this.trainersLoader = false;
              })
              .catch(e => {
                console.log(e.response);
                this.trainersLoader = false;

                this.snackbarContent = "Error getting data.";
                this.snackbarColor = "error";
                this.snackbar = true;
              });
          })
          .catch(e => {
            console.log(e.response);
          });
      }
    },
    validityDateChosen() {
      this.$refs.smenu.save(this.validityDate);
      this.validityDateFormatted = this.formatDate(this.validityDate);
    },
    editTrainer(item) {
      console.log(item);

      let date = new Date(item.dateOfBirth);

      this.firstname = item.firstname;
      this.lastname = item.lastname;
      this.genderSelect = item.gender;
      this.phonenumber = item.phoneNumber;

      this.email = item.email;
      this.emailDisabled = true;

      this.day = this.days[date.getDate() - 1];
      this.month = this.months[date.getMonth()];
      this.year = date.getFullYear();

      this.pincode = item.address.pinCode;
      this.street = item.address.address;
      this.city = item.address.city;
      this.certificateNumber = item.certificateNumber;

      this.trainerDialogTitle = "Modifier le formateur";
      this.trainerDialogAction = 2;

      if (item.subType == "PSYCHOLOGIST") {
        this.typeOfTrainer = 2;
      } else if (item.subType == "BAFM") {
        this.typeOfTrainer = 1;
      }

      this.addressID = item.address.id;

      this.trainerEditID = item.id;

      this.trainerDialog = true;
    },
    deleteTrainer(item) {
      console.log(item);

      this.$http
        .put(
          "/training-center/" + this.user.id + "/block-user/" + item.id,
          {},
          {
            headers: { Authorization: "Bearer " + this.$store.state.token }
          }
        )
        .then(res => {
          console.log(res);

          this.$http
            .get("/training-center/" + this.user.id + "/findAll/trainer", {
              headers: { Authorization: "Bearer " + this.$store.state.token }
            })
            .then(res => {
              this.trainers = res.data;

              console.log(this.trainers);
              this.trainersLoader = false;
            })
            .catch(e => {
              console.log(e.response);
              this.trainersLoader = false;

              this.snackbarContent = "Error getting data.";
              this.snackbarColor = "error";
              this.snackbar = true;
            });
        })
        .catch(e => {
          console.log(e.response);

          this.snackbarContent = "Error blocking user.";
          this.snackbarColor = "error";
          this.snackbar = true;

          this.trainersLoader = false;
        });
    },
    openBlockUserDialog(id, blockedStatus) {
      if (blockedStatus == false) {
        this.blockDialogTitle = "débloquer le formateur?";
      } else {
        this.blockDialogTitle = "bloquer User?";
      }
      this.blockId = id;
      this.blockUserDialog = true;
    },
    blockUnblockUser() {
      this.$http
        .put(
          "/training-center/" + this.user.id + "/block-user/" + this.blockId,
          {},
          {
            headers: { Authorization: "Bearer " + this.$store.state.token }
          }
        )
        .then(res => {
          if (res.status == 200) {
            if (res.data == false) {
              this.snackbar = true;
              this.snackbarContent = "User Blocked";
              this.snackbarColor = "warning";
            } else {
              this.snackbar = true;
              this.snackbarContent = "User Unblocked";
              this.snackbarColor = "success";
            }
          }
          this.$http
            .get("/training-center/" + this.user.id + "/findAll/trainer", {
              headers: { Authorization: "Bearer " + this.$store.state.token }
            })
            .then(res => {
              this.trainers = res.data;

              console.log(this.trainers);
              this.trainersLoader = false;
            })
            .catch(e => {
              console.log(e.response);
              this.trainersLoader = false;

              this.snackbarContent = "Error getting data.";
              this.snackbarColor = "error";
              this.snackbar = true;
            });

          this.blockUserDialog = false;
        })
        .catch(e => {
          console.log(e.response);
        });
    },

    // ---------------------------------------------------- End Trainer register, edit, delete ----------------------------------------------------------//

    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = this.today;
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    updateRange({ start, end }) {
      // You could load events from an outside source (like database) now that we have the start and end dates on the calendar
      this.start = start;
      this.end = end;
    },
    getEvents() {
      this.calendarLoader = true;
      this.$http
        .get(
          "/training-center/" +
            this.user.id +
            "/trainer/" +
            this.trainerID +
            "/schedule/findAll",
          {
            headers: { Authorization: "Bearer " + this.$store.state.token }
          }
        )
        .then(res => {
          console.log(res.data);
          let events = res.data;
          let color = null;

          events.forEach((event, i) => {
            if (event.available == false) {
              color = "red";
            } else {
              color = "event";
            }

            this.events.push({
              id: event.id,
              name: moment(event.scheduleDate).format("DD/MM/YYYY"),
              start: event.scheduleDate,
              end: event.scheduleDate,
              color: color,
              internshipID: event.internshipId,
              available: event.available
            });
          });

          this.calendarLoader = false;
        })
        .catch(e => {
          //console.log(e.response);
          this.calendarLoader = false;
        });
    },
    showEvent({ nativeEvent, event }) {
      //console.log(event);
      if (event.available == false) {
        const open = () => {
          this.$http
            .get("/public/internship/" + event.internshipID + "/findById")
            .then(res => {
              console.log(res.data);

              this.selectedEvent = res.data;
            })
            .catch(e => {
              console.log(e);
            });

          this.selectedElement = nativeEvent.target;
          setTimeout(() => (this.selectedOpen = true), 10);
        };

        if (this.selectedOpen) {
          this.selectedOpen = false;
          setTimeout(open, 10);
        } else {
          open();
        }

        nativeEvent.stopPropagation();
      }
    },

    openViewScheduleDialog(item) {
      //console.log(item);

      this.formValidSchedule = false;
      this.events = [];
      this.trainerID = item.id;
      this.getEvents();
      this.trainerScheduleDialogTitle = item.firstname + " " + item.lastname;

      this.viewScheduleDialog = true;
    }
  },
  computed: {
    years: function() {
      let d = new Date().getFullYear();

      let end = d - 60;
      let start = d - 18;

      let t = [];
      for (let i = start; i >= end; i--) {
        t.push(i);
      }

      return t;
    },
    user() {
      return this.$store.getters.getUser;
    },
    title() {
      const start = this.start;
      const end = this.end;
      if (!start || !end) {
        return "";
      }

      const startMonth = this.monthFormatter(start);

      const startYear = start.year;

      return `${startMonth} ${startYear}`;
    },
    monthFormatter() {
      return this.$refs.calendar.getFormatter({
        timeZone: "UTC",
        month: "long"
      });
    }
  }
};
</script>